import { createAsyncThunk } from '@reduxjs/toolkit'
import { fetchUserPartnerList } from 'legacy/lut/services/partner/partnerDashboard'

import { StorageApiKeys } from 'clickNgo/configs/service/storage'
import { IPartnerRecord } from 'clickNgo/entities/partner/models'
import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { StorageApi } from 'core/classes/services/api/StorageApi'

import { INIT_PARTNER_DASHBOARD_ACTION_TYPE } from '../configs'
import { getLocalUserHistory } from '../helpers/getLocalUserHistory'
import { setLocalUserHistory } from '../helpers/setLocalUserHistory'

export interface IInitPartnerDashboardParams {
  userEmail: string
  options?: ICrudFetchOptions
}

/** Initialize partner dashboard - ./listeners/initPartnerDashboardListener */
export const initPartnerDashboardAction = createAsyncThunk(
  INIT_PARTNER_DASHBOARD_ACTION_TYPE,
  async ({ userEmail, options }: IInitPartnerDashboardParams) => {
    const partnerList = await fetchUserPartnerList(userEmail, {
      ...options,
      paging: { pageSize: 10000, page: 0 },
    })

    const remoteUserHistory = StorageApi.get(StorageApiKeys.UserHistory) as IPartnerRecord[]
    const localUserHistory = getLocalUserHistory()

    let userHistoryList: IPartnerRecord[] = localUserHistory

    if (!remoteUserHistory) {
      StorageApi.set(StorageApiKeys.UserHistory, localUserHistory)
      userHistoryList = localUserHistory
    } else {
      setLocalUserHistory(remoteUserHistory)
      userHistoryList = remoteUserHistory
    }

    return { partnerList, userHistoryList }
  }
)
